import apiNotification from '../apiNotification'

export default {
  GetNotificationStopped: async () => {
    return await apiNotification.get('stopped');
  },
  GetNotificationMaintenance: async () => {
    return await apiNotification.get('mnt');
  }
}
